import _ from "lodash";

export const generateLabelList = (currentQuestion) => {
  let optionLabels = {};

  currentQuestion.options.forEach((option) => {
    if (option.id) {
      const obj = { [option.id]: option.label };
      optionLabels = { ...optionLabels, ...obj };
    }
  });

  return optionLabels;
};

export const generateKeyList = (clonedData, isDepended) => {
  const { redirectNondependentIndexList, redirectDependentIndexList } =
    generateRedirectFlowList(clonedData);

  const redirectIndexList = isDepended
    ? redirectDependentIndexList
    : redirectNondependentIndexList;
  return Object.keys(redirectIndexList).map((data) => Number(data));
};

export const getParentIndex = (
  redirectNondependentIndexList,
  redirectDependentIndexList,
  selectedIndex,
  dependedkeyList,
  parentIndex = null
) => {
  const recursiveLooping = (
    redirectDependentIndexList,
    selectedIndex,
    currentIndex,
    parentIndex,
    isParent = false
  ) => {
    if (!_.isEmpty(redirectDependentIndexList[currentIndex]) && !isParent) {
      const value = redirectDependentIndexList[currentIndex];
      for (const subkey in value) {
        if (value[subkey]?.includes(selectedIndex)) {
          return (isParent = true);
        } else {
          // eslint-disable-next-line no-loop-func
          value[subkey]?.forEach((subvalue) => {
            if (!value[subkey]?.includes(currentIndex)) {
              isParent = recursiveLooping(
                redirectDependentIndexList,
                selectedIndex,
                subvalue,
                parentIndex,
                isParent
              );
            }
          });
        }
      }
    }
    return isParent;
  };

  for (const key in redirectNondependentIndexList) {
    const value = redirectNondependentIndexList[key];

    for (const subkey in value) {
      const subValue = value[subkey];
      if (parentIndex === null) {
        if (subValue.includes(selectedIndex)) {
          parentIndex = Number(key);
        } else {
          // eslint-disable-next-line no-loop-func
          subValue?.forEach((subvalue) => {
            if (
              dependedkeyList.includes(subvalue) &&
              !_.isEmpty(redirectDependentIndexList[subvalue]) &&
              !subValue.includes(Number(key))
            ) {
              const isParent = recursiveLooping(
                redirectDependentIndexList,
                selectedIndex,
                subvalue,
                Number(key)
              );
              if (isParent) {
                parentIndex = Number(key);
              }
            }
          });
        }
      }
    }
  }
  return parentIndex;
};

const nodeDependentList = (allQuestions, dependentId) => {
  const dependentIndex = [];
  allQuestions.forEach((question, index) => {
    if (question.dependedId !== "") {
      if (
        typeof question.dependedId === "string" &&
        question.dependedId === dependentId
      ) {
        dependentIndex.push(index);
      } else if (Array.isArray(question.dependedId)) {
        question.dependedId.forEach((id) => {
          if (id === dependentId) {
            dependentIndex.push(index);
          }
        });
      }
    }
  });

  return dependentIndex;
};

export const generateRedirectFlowList = (allQuestions) => {
  let redirectNondependentIndexList = {};
  let redirectDependentIndexList = {};

  allQuestions?.forEach((question, questionIndex) => {
    const dependentOptionList = question?.options
      ?.filter((option) => option?.id)
      .map((option) => option?.id);
    let optionsDependentList = {};
    if (["dropdown", "multi-select", "select", "image-multi-select", "image-select"].includes(question.type)) {
      optionsDependentList = dependentOptionList.reduce((result, option) => {
        const dependentIndexList = nodeDependentList(allQuestions, option);
        result[option] = dependentIndexList;
        return result;
      }, {});
    }

    if (!question.isDepended) {
      const obj = { [questionIndex]: optionsDependentList };
      redirectNondependentIndexList = {
        ...redirectNondependentIndexList,
        ...obj,
      };
    } else {
      const obj = { [questionIndex]: optionsDependentList };
      redirectDependentIndexList = { ...redirectDependentIndexList, ...obj };
    }
  });

  return { redirectNondependentIndexList, redirectDependentIndexList };
};

const findNextRedirentIndex = (
  subData,
  allQuestions,
  selectedIndex,
  nextIndexArray,
  redirectDependentIndexList,
  nextNonDependedIndex,
  parentKey,
  next = []
) => {
  const findIndex = (
    selectedIndex,
    currentIndex,
    nextNonDependedIndex,
    nextIndexArray,
    optionLabel = "",
    visiteIndexArray = []
  ) => {
    if (
      selectedIndex === currentIndex &&
      !visiteIndexArray.includes(currentIndex)
    ) {
      visiteIndexArray.push(currentIndex);
      if (_.isEmpty(redirectDependentIndexList[currentIndex.toString()])) {
        next = [...next, nextNonDependedIndex];
        const obj = {
          optionName: optionLabel ? optionLabel : "All other cases",
          nextIndex: nextNonDependedIndex,
        };
        nextIndexArray.push(obj);
      } else {
        let isConnected = false;
        Object.entries(
          redirectDependentIndexList[currentIndex.toString()]
        )?.forEach(([subkey, subvalue]) => {
          const nextI = subvalue[0] ? subvalue[0] : nextNonDependedIndex;
          next = [...next, nextI];
          if (_.isEmpty(subvalue) && !isConnected) {
            const obj = { optionName: "All other cases", nextIndex: nextI };
            nextIndexArray.push(obj);
            isConnected = true;
          }
        });
      }
    } else if (!visiteIndexArray.includes(currentIndex)) {
      if (redirectDependentIndexList[currentIndex.toString()]) {
        visiteIndexArray.push(currentIndex);
        Object.entries(
          redirectDependentIndexList[currentIndex.toString()]
        )?.forEach(([key, value]) => {
          if (!value.includes(currentIndex)) {
            const currentOptionLabel = generateLabelList(
              allQuestions[currentIndex]
            );
            if (value.includes(selectedIndex)) {
              const subValueIndex = value.indexOf(selectedIndex);
              const nextI = value[subValueIndex + 1]
                ? value[subValueIndex + 1]
                : nextNonDependedIndex;
              if (
                _.isEmpty(redirectDependentIndexList[selectedIndex.toString()])
              ) {
                next = [...next, nextI];
                const obj = {
                  optionName: `${optionLabel + ` & ` + currentOptionLabel[key]
                    }`,
                  nextIndex: nextI,
                };
                nextIndexArray.push(obj);
              } else {
                findIndex(
                  selectedIndex,
                  selectedIndex,
                  nextI,
                  nextIndexArray,
                  `${optionLabel + ` & ` + currentOptionLabel[key]}`,
                  visiteIndexArray
                );
              }
            } else {
              value?.forEach((subIndex) => {
                const subValueIndex = value.indexOf(subIndex);
                const nextNode = value[subValueIndex + 1]
                  ? value[subValueIndex + 1]
                  : nextNonDependedIndex;
                findIndex(
                  selectedIndex,
                  subIndex,
                  nextNode,
                  nextIndexArray,
                  `${optionLabel + ` & ` + currentOptionLabel[key]}`,
                  visiteIndexArray
                );
              });
            }
          }
        });
      }
    }
  };

  let isValueEmpty = false;
  Object.entries(subData)?.forEach(([subkey, subvalue]) => {
    const optionLabel = generateLabelList(allQuestions[Number(parentKey)]);
    if (!subvalue.includes(Number(parentKey))) {
      if (
        _.isEmpty(subvalue) &&
        !isValueEmpty &&
        selectedIndex === Number(parentKey)
      ) {
        const obj = {
          optionName: "All other cases",
          nextIndex: nextNonDependedIndex,
        };
        nextIndexArray.push(obj);
        isValueEmpty = true;
      } else {
        subvalue.forEach((currentIndex) => {
          const subValueIndex = subvalue.indexOf(currentIndex);
          const nextNode = subvalue[subValueIndex + 1]
            ? subvalue[subValueIndex + 1]
            : nextNonDependedIndex;
          findIndex(
            selectedIndex,
            currentIndex,
            nextNode,
            nextIndexArray,
            optionLabel[subkey]
          );
        });
      }
    }
  });
};

export const RedirectIndex = (
  selectedIndex,
  allQuestions,
  nextIndexArray = []
) => {
  const { redirectNondependentIndexList, redirectDependentIndexList } =
    generateRedirectFlowList(allQuestions);
  let nextIndex = "";

  const nonDependKeyList = Object.keys(redirectNondependentIndexList).map(
    (data) => Number(data)
  );

  const keyList = nonDependKeyList;
  const redirectList = redirectNondependentIndexList;

  if (
    allQuestions[selectedIndex] &&
    allQuestions[selectedIndex].isDepended === true &&
    allQuestions[selectedIndex].dependedId === ""
  ) {
    nextIndex = "noConnection";
  } else {
    Object.entries(redirectList).forEach(([key, value]) => {
      if (
        keyList.includes(selectedIndex) &&
        _.isEmpty(value) &&
        selectedIndex === Number(key)
      ) {
        const nextNonDependedIndex =
          keyList[keyList.indexOf(Number(selectedIndex)) + 1];
        const nextNondepended = nextNonDependedIndex
          ? nextNonDependedIndex
          : "end";
        nextIndex = nextNondepended;
        const obj = {
          optionName: "All other cases",
          nextIndex: nextNondepended,
        };
        nextIndexArray.push(obj);
      } else {
        const data = value;
        const nextNonDependedIndex = keyList[keyList.indexOf(Number(key)) + 1]
          ? keyList[keyList.indexOf(Number(key)) + 1]
          : "end";
        nextIndex = findNextRedirentIndex(
          data,
          allQuestions,
          selectedIndex,
          nextIndexArray,
          redirectDependentIndexList,
          nextNonDependedIndex,
          key
        );
      }
    });
  }
  return _.isEmpty(nextIndexArray) ? nextIndex : nextIndexArray;
};
